<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <h2 class="text-xl font-semibold mb-4">Lyfis Questions</h2>
  <div class="flex justify-end items-center w-full mb-3">
    <div nz-row nzjusty nzJustify="end" nzAlign="middle">
      <button (click)="openCreateDrawer()" nz-button nzType="primary">
        Create Question
      </button>
    </div>
  </div>
  <nz-table
    [nzData]="data"
    [nzLoading]="tableLoading"
    [nzFrontPagination]="false"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzTotal]="totalRecords"
    (nzPageIndexChange)="onPageIndexChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>
          Internal Label
          <nz-filter-trigger
            [nzActive]="!!internalLabelSearch"
            [nzDropdownMenu]="internalLabelMenu"
          >
            <span nz-icon nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>Question</th>
        <th>
          Answer Type
          <nz-filter-trigger
            [nzActive]="selectedAnswerTypes.length > 0"
            [nzDropdownMenu]="answerTypeMenu"
          >
            <span nz-icon nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>Options</th>
        <th>
          Diseases
          <nz-filter-trigger
            [nzActive]="selectedDiseaseIds.length > 0"
            [nzDropdownMenu]="diseaseMenu"
          >
            <span nz-icon nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Active
          <nz-switch
            [ngModel]="activeFilter === true"
            (ngModelChange)="onActiveToggle($event)"
            [nzCheckedChildren]="'true'"
            [nzUnCheckedChildren]="'false'"
            style="margin-left: 8px"
          ></nz-switch>
        </th>
        <th>
          Order
          <nz-filter-trigger
            [nzActive]="!!orderSort"
            [nzDropdownMenu]="orderSortMenu"
          >
            <span nz-icon nzType="filter"></span>
          </nz-filter-trigger>
        </th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of data">
        <td>{{ r.internalLabel }}</td>
        <td>{{ r.question }}</td>
        <td>{{ r.answerType }}</td>
        <td>
          <ng-container *ngIf="r.options?.length; else noOpts">
            <span *ngFor="let o of r.options; let last = last">
              {{ o.label }}<span *ngIf="!last">, </span>
            </span>
          </ng-container>
          <ng-template #noOpts>-</ng-template>
        </td>
        <td>
          <span
            *ngFor="let d of getDiseaseNames(r.diseaseIds); let last = last"
          >
            <nz-tag [nzColor]="'blue'" class="m-1">{{ d }}</nz-tag>
          </span>
        </td>

        <td>
          <nz-tag [nzColor]="r.active ? 'green' : 'red'">{{
            r.active ? "Active" : "Inactive"
          }}</nz-tag>
        </td>
        <td>{{ r.order }}</td>
        <td>
          <button
            nz-button
            nzType="default"
            nzShape="circle"
            (click)="openViewDrawer(r)"
            nz-tooltip
            nzTooltipTitle="View"
          >
            <span nz-icon nzType="eye"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <!-- Internal Label Filter -->
  <nz-dropdown-menu #internalLabelMenu="nzDropdownMenu">
    <div
      class="bg-white shadow-lg rounded-md p-3"
      style="display: flex; flex-direction: column; gap: 8px; min-width: 260px"
    >
      <span class="font-semibold text-gray-700">Search Internal Label</span>
      <input
        nz-input
        placeholder="Enter internal label"
        [(ngModel)]="internalLabelTemp"
      />
      <div class="flex justify-end gap-2">
        <button nz-button nzType="default" (click)="resetInternalLabelSearch()">
          Reset
        </button>
        <button nz-button nzType="primary" (click)="applyInternalLabelSearch()">
          Ok
        </button>
      </div>
    </div>
  </nz-dropdown-menu>

  <!-- Answer Type Filter -->
  <nz-dropdown-menu #answerTypeMenu="nzDropdownMenu">
    <div
      class="bg-white shadow-lg rounded-md p-3"
      style="
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 260px;
        max-height: 400px;
        overflow: auto;
      "
    >
      <span class="font-semibold text-gray-700">Filter by Answer Type</span>
      <nz-checkbox-wrapper (nzOnChange)="onAnswerTypeTempChange($event)">
        <div *ngFor="let opt of answerTypeOptions" class="py-1">
          <label
            nz-checkbox
            [nzValue]="opt.value"
            [ngModel]="answerTypeTemp.includes(opt.value)"
          >
            <span class="text-sm text-gray-700 whitespace-nowrap">{{
              opt.label
            }}</span>
          </label>
        </div>
      </nz-checkbox-wrapper>
      <div class="flex justify-end gap-2">
        <button nz-button nzType="default" (click)="resetAnswerTypeFilter()">
          Reset
        </button>
        <button nz-button nzType="primary" (click)="applyAnswerTypeFilter()">
          Ok
        </button>
      </div>
    </div>
  </nz-dropdown-menu>

  <!-- Order Sort Filter -->
  <nz-dropdown-menu #orderSortMenu="nzDropdownMenu">
    <div
      class="bg-white shadow-lg rounded-md p-3"
      style="display: flex; flex-direction: column; gap: 8px; min-width: 200px"
    >
      <span class="font-semibold text-gray-700">Sort by Order</span>
      <nz-radio-group [(ngModel)]="orderSort">
        <label nz-radio [nzValue]="'ASC'">ASC</label>
        <label nz-radio [nzValue]="'DESC'">DESC</label>
      </nz-radio-group>
      <div class="flex justify-end gap-2">
        <button
          nz-button
          nzType="default"
          (click)="onOrderSortChange(undefined)"
        >
          Reset
        </button>
        <button
          nz-button
          nzType="primary"
          (click)="onOrderSortChange(orderSort)"
        >
          Ok
        </button>
      </div>
    </div>
  </nz-dropdown-menu>

  <!-- Disease Filter -->
  <nz-dropdown-menu #diseaseMenu="nzDropdownMenu">
    <div
      class="bg-white shadow-lg rounded-md p-3"
      style="display: flex; flex-direction: column; gap: 8px; min-width: 260px"
    >
      <span class="font-semibold text-gray-700">Filter by Diseases</span>
      <nz-checkbox-wrapper (nzOnChange)="onDiseaseTempChange($event)">
        <div *ngFor="let opt of diseaseOptions" class="py-1">
          <label
            nz-checkbox
            [nzValue]="opt.id"
            [ngModel]="diseaseTemp.includes(opt.id)"
          >
            <span class="text-sm text-gray-700 whitespace-nowrap">{{
              opt.name
            }}</span>
          </label>
        </div>
      </nz-checkbox-wrapper>
      <div class="flex justify-end gap-2">
        <button nz-button nzType="default" (click)="resetDiseaseFilter()">
          Reset
        </button>
        <button nz-button nzType="primary" (click)="applyDiseaseFilter()">
          Ok
        </button>
      </div>
    </div>
  </nz-dropdown-menu>

  <!-- Create / Update Drawer -->
</div>

<nz-drawer
  [nzVisible]="createDrawerVisible"
  nzPlacement="right"
  nzTitle="{{
    drawerMode === 'create'
      ? 'Create Lyfis Question'
      : drawerMode === 'view'
        ? 'View Lyfis Question'
        : 'Edit Lyfis Question'
  }}"
  [nzWidth]="520"
  (nzOnClose)="closeCreateDrawer()"
>
  <ng-container *nzDrawerContent>
    <div class="flex justify-end items-center">
      <div>
        <button
          *ngIf="drawerMode === 'view'"
          nz-button
          nzType="primary"
          (click)="enterEditMode()"
        >
          Edit
        </button>
        <button
          *ngIf="drawerMode === 'edit'"
          nz-button
          nzType="default"
          (click)="cancelEdit()"
        >
          Cancel
        </button>
      </div>
    </div>
    <form [formGroup]="questionForm" class="flex flex-col gap-3">
      <div nz-row nzGutter="12">
        <div nz-col nzSpan="12">
          <label class="block text-sm">Internal Label</label>
          <input
            nz-input
            formControlName="internalLabel"
            placeholder="e.g. bp_systolic"
          />
        </div>
        <div nz-col nzSpan="12">
          <label class="block text-sm">Label</label>
          <input
            nz-input
            formControlName="label"
            placeholder="e.g. Systolic Blood Pressure"
          />
        </div>
      </div>

      <div nz-row nzGutter="12">
        <div nz-col nzSpan="12">
          <label class="block text-sm">Order</label>
          <input nz-input type="number" formControlName="order" />
        </div>
        <div nz-col nzSpan="12">
          <label class="block text-sm">Active</label>
          <nz-switch formControlName="active"></nz-switch>
        </div>
      </div>

      <div>
        <label class="block text-sm">Question</label>
        <input
          nz-input
          formControlName="question"
          placeholder="Enter question text"
        />
      </div>

      <div>
        <label class="block text-sm">Question Description</label>
        <textarea
          nz-input
          formControlName="questionDescription"
          rows="3"
          placeholder="Optional description for additional context"
        ></textarea>
      </div>

      <div nz-row nzGutter="12" class="w-full">
        <div nz-col nzSpan="12" class="w-1/3">
          <label class="block text-sm">Diseases</label>
          <nz-select
            formControlName="diseaseIds"
            nzPlaceHolder="Select diseases"
            nzMode="multiple"
            class="w-full"
          >
            <nz-option
              *ngFor="let d of diseaseOptions"
              [nzValue]="d.id"
              [nzLabel]="d.name"
            ></nz-option>
          </nz-select>
        </div>
        <div nz-col nzSpan="12" class="w-1/3">
          <label class="block text-sm">Fact</label>
          <nz-select
            formControlName="factId"
            nzPlaceHolder="Select facts"
            nzMode="multiple"
            class="w-full"
          >
            <nz-option
              *ngFor="let f of factOptions"
              [nzValue]="f.id"
              [nzLabel]="f.name"
            ></nz-option>
          </nz-select>
        </div>
      </div>

      <div nz-row nzGutter="12" nzAlign="middle">
        <div nz-col nzSpan="16">
          <label class="block text-sm">Answer Type</label>
          <div class="flex flex-row gap-4">
            <nz-select formControlName="answerType">
              <nz-option
                *ngFor="let opt of answerTypeOptionsFiltered"
                [nzValue]="opt.value"
                [nzLabel]="opt.label"
              ></nz-option>
            </nz-select>
            <div
              nz-col
              nzSpan="12"
              *ngIf="shouldShowAllowMultiple()"
              class="flex items-center"
            >
              <label
                nz-checkbox
                formControlName="allowMultiple"
                class="flex items-center h-full"
              >
                <span class="text-sm">Allow Multiple</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="shouldShowPlaceholder()">
        <label class="block text-sm">Placeholder</label>
        <input
          nz-input
          formControlName="placeholder"
          placeholder="Enter placeholder text"
        />
      </div>

      <div formGroupName="cadence">
        <label class="block text-sm">Cadence - Min Interval Days</label>
        <input nz-input type="number" formControlName="minIntervalDays" />
      </div>

      <ng-container *ngIf="shouldShowOptions()">
        <div class="flex items-center justify-between">
          <label class="block text-sm">Options</label>
          <button
            nz-button
            nzType="dashed"
            (click)="addOption()"
            [disabled]="shouldDisableOptionsEditing()"
          >
            Add Option
          </button>
        </div>
        <div formArrayName="options" class="flex flex-col gap-2">
          <div
            *ngFor="let opt of optionsForm.controls; let i = index"
            [formGroupName]="i"
            class="border rounded p-2"
          >
            <div nz-row nzGutter="8" class="gap-2">
              <div nz-col nzSpan="16">
                <input
                  nz-input
                  formControlName="label"
                  placeholder="Label"
                  [disabled]="shouldDisableOptionsEditing()"
                />
              </div>
              <div nz-col nzSpan="8" class="flex items-center gap-1">
                <input
                  nz-input
                  type="number"
                  formControlName="order"
                  placeholder="#"
                  [disabled]="shouldDisableOptionsEditing()"
                />
                <button
                  nz-button
                  nzType="default"
                  nzDanger
                  (click)="removeOption(i)"
                  [disabled]="shouldDisableOptionsEditing()"
                >
                  Remove
                </button>
              </div>
            </div>
            <div nz-row class="mt-2" *ngIf="shouldShowIsDefaultOptions()">
              <div nz-col nzSpan="24">
                <label
                  nz-checkbox
                  formControlName="isDefault"
                  (nzCheckedChange)="onDefaultOptionChange(i)"
                  [disabled]="shouldDisableOptionsEditing()"
                >
                  <span class="text-xs">Is Default</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="shouldShowArrayDefinitions()">
        <div class="flex items-center justify-between">
          <label class="block text-sm">Array Definitions</label>
        </div>
        <div formArrayName="arrayDefinitions" class="flex flex-col gap-2">
          <div
            *ngFor="let def of arrayDefinitionsForm.controls; let i = index"
            [formGroupName]="i"
            class="border rounded p-3"
          >
            <div class="mb-2">
              <label class="block text-xs text-gray-600"
                >Fact Key: {{ def.get("factKey")?.value }}</label
              >
            </div>
            <div class="mb-2">
              <label class="block text-xs">Placeholder</label>
              <input
                nz-input
                formControlName="placeHolder"
                placeholder="Enter placeholder"
              />
            </div>
            <div formGroupName="validation" class="grid grid-cols-3 gap-2">
              <div>
                <label class="block text-xs">Min</label>
                <input nz-input type="number" formControlName="min" />
              </div>
              <div>
                <label class="block text-xs">Max</label>
                <input nz-input type="number" formControlName="max" />
              </div>
              <div>
                <label class="block text-xs">Regex</label>
                <input nz-input formControlName="regex" placeholder="^\\d+$" />
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="shouldShowValidation()">
        <div formGroupName="validation" class="grid grid-cols-3 gap-2">
          <div>
            <label class="block text-sm">Min</label>
            <input nz-input type="number" formControlName="min" />
          </div>
          <div>
            <label class="block text-sm">Max</label>
            <input nz-input type="number" formControlName="max" />
          </div>
          <div>
            <label class="block text-sm">Regex</label>
            <input nz-input formControlName="regex" placeholder="^\\d+$" />
          </div>
        </div>
      </ng-container>

      <div class="mt-4 flex justify-between gap-2">
        <div>
          <button
            *ngIf="drawerMode !== 'view'"
            nz-button
            nzType="primary"
            [nzLoading]="saving"
            (click)="onSave()"
          >
            {{ drawerMode === "create" ? "Save" : "Update" }}
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</nz-drawer>
